import { CaseInterceptor, HeaderInterceptor } from '@core/interceptors';
import { RetryTimeoutInterceptor } from '@core/interceptors/retry-timeout.interceptor';
import { CommonModule, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { CookieService } from 'ngx-cookie-service';
import { FooterModule } from '@shared/components/footer/footer.module';
import { HeaderModule } from '@shared/components/header/header.module';
import { NavbarModule } from '@shared/components/navbar/navbar.module';
import { PauseMenuModule } from '@shared/components/pause-menu/pause-menu.module';
import { RouterModule } from '@angular/router';
import { SubscriptionShopListModule } from '@shared/components/dialogs/subscription-shop-list/subscription-shop-list.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import localeRu from '@angular/common/locales/ru';
import { SubscriptionGuardDialogModule } from '@shared/components/dialogs/subscription-guard-dialog/subscription-guard-dialog.module';
import { NetworkErrorDialogModule } from '@shared/components/dialogs/network-error-dialog/network-error-dialog.module';

registerLocaleData(localeRu);
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatMomentDateModule,
    RouterModule,
    HttpClientModule,
    SubscriptionShopListModule,
    SubscriptionGuardDialogModule,
    NetworkErrorDialogModule,
  ],
  exports: [HeaderModule, NavbarModule, FooterModule, PauseMenuModule],
  providers: [
    {
      // Первым в цепочке: каждая ретрай-попытка проходит через остальные
      // интерцепторы (Header с 401-refresh, Case, AccessDenied) заново.
      provide: HTTP_INTERCEPTORS,
      useClass: RetryTimeoutInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CaseInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'ru',
    },
    CookieService,
  ],
})
export class CoreModule {}
